import React from 'react'
import Header from '../Components/Header';
import Showlist from '../Components/Showlist';
import About from '../Components/About';
import Footer from '../Components/Footer';
import Upcoming from '../Components/Upcoming';
import Showact from '../Components/Showact';
import Partners from '../Components/Partners';
import Supportedasso from '../Components/Supportedasso';
import Liveupdate from '../Components/Liveupdate';
import Testimonial from '../Components/Testimonial';
import Latestproduct from '../Components/Latestproduct';


import slide01 from '../assests/img/lab-banner-new01.jpg';
import slide02 from '../assests/img/lab-banner-new02.jpg';
import slide03 from '../assests/img/lab-banner-new03.jpg';
import slide04 from '../assests/img/lab-banner-new04.jpg';
import slide05 from '../assests/img/lab-banner-new05.jpg';
import slide06 from '../assests/img/lab-banner-new06.jpg';
import { Helmet } from "react-helmet-async";


import Slider from "react-slick";
import Bestsellerproduct from '../Components/Bestsellerproduct';

function App() {
   
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

return (
    <div >
     <Helmet>
        <title>Labway Scientific System | Complete Range of Educational Apparatus & Laboratory Instruments</title>
        <meta
          name="description"
          content="Explore the Jaipur Silver Show by Aadikaash International — India’s biggest B2B Silver Jewellery Exhibition showcasing premium silver creations."
        />
        <meta
          name="keywords"
          content="Jaipur Silver Show, Silver Show of India, Silver Jewellery Show in Jaipur, Aadikaash International, Silver Jewellery Exhibition, B2B Silver Show"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}

<div className='main-slider'>
      <Slider {...settings}>
      <div>
       <img src={slide01}/>
      </div>
      <div>
       <img src={slide02}/>
      </div>
       <div>
       <img src={slide03}/>
      </div>
      <div>
       <img src={slide04}/>
      </div>
      <div>
       <img src={slide05}/>
      </div>
       <div>
       <img src={slide06}/>
      </div>
    </Slider>


      </div>
<About/>
<Bestsellerproduct/>
{/* <Liveupdate/> */}
<Showact/>
<Latestproduct/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<Footer/>
 </div>
)

}

export default App;
